var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import _map from 'lodash/map';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import ActionModal from '../../containers/modals/url';
const portTranslator = (node) => {
    return [
        {
            id: uuid(),
            type: 'out',
            label: 'Default',
            connection: node.payload.defaultUrl || uuid(),
        },
        ..._map(node.payload.urls, (connection, label) => ({
            id: uuid(),
            type: 'out',
            label,
            connection,
        })),
    ];
};
export class URLTriggerNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        const { node: { payload: { urls }, }, } = this.props;
        const urlCount = Object.keys(urls).length;
        const text = urlCount === 1 ? 'URL' : `URLs`;
        return (_jsx(FlowNode, { color: URLTriggerNode.color, icon: URLTriggerNode.icon, label: URLTriggerNode.label, text: _jsxs("strong", { children: [urlCount, " ", text] }), onEdit: this.triggerEdit }));
    }
}
URLTriggerNode.icon = 'url-trigger';
URLTriggerNode.label = 'URL Trigger';
URLTriggerNode.color = flowNodeColor.purple;
URLTriggerNode.translatePayload = formatPortsHelper(portTranslator);
URLTriggerNode.ActionModal = ActionModal;
URLTriggerNode.actionTrigger = { type: FlowNodeTypes.URL };
URLTriggerNode.updateConnection = (node, port, newConnection) => {
    if (!port)
        return node;
    const newNode = Object.assign({}, node);
    if (port.label === 'Default') {
        newNode.payload.defaultUrl = newConnection;
    }
    else if (port.label && newNode.payload.urls[port.label]) {
        newNode.payload.urls[port.label] = newConnection;
    }
    return newNode;
};
__decorate([
    boundMethod
], URLTriggerNode.prototype, "triggerEdit", null);
